import axios from 'axios';
import type { TSendMtanPayload, TMtanTerminationPayload } from './types';

export const sendMtan = async (
    { contactId, templateMetadataKey }:TSendMtanPayload,
) => axios.post(
    `${global?.AppConfig?.DSL_URL_SUFFIX}/v1/mtan/${contactId}/send`,
    { templateMetadataKey },
);

export const mtanTermination = async (
    { contactId, portfolioId, body }:TMtanTerminationPayload,
) => axios.post(
    `${global?.AppConfig?.DSL_URL_SUFFIX}/v1/contacts/${contactId}/portfolios/${portfolioId}/termination`,
    body,
);
